<template>
  <div class="image-input p-4">
    <div class="columns is-multiline">
      <!-- preview image -->
      <div class="column is-4-desktop">
        <div class="d-flex justify-content-center align-items-center mt-1 mb-4">
          <div class="image-input__image-wrapper">
            <img class="image-input__image" :src="value.src" alt="" />
          </div>
        </div>
      </div>

      <!-- description -->
      <div
          v-if="!hideDescription"
          class="column is-8-desktop"
      >
        <image-description
          :value="value.description"
          :disabled="disabled"
          :error="false"
          :inverted="true"
          :label="i18nDescriptionLabel"
          :mapping="{ attributes: { maxLength: 256 } }"
          :placeholder="i18nDescriptionPlaceholder"
          class="image-input__textarea"
          @input="onDescriptionInput"
        ></image-description>
      </div>

      <!-- image meta data -->
      <div class="column is-full">
        <div class="columns">
          <div class="column is-6-tablet">
            <div class="text-bold">
              {{ value.name }}
            </div>
            <div :class="{ 'is-danger': customErrors.size }">
              {{
                $t("images.upload.imageInput.size", {
                  size: filesizehumanreadable(value.size, lang),
                })
              }}
            </div>
          </div>
          <div class="column is-6-tablet is-clearfix">
            <button
              :disabled="disabled"
              type="button"
              class="button is-danger is-pulled-right"
              @click="removeImage"
            >
              <span class="icon">
                <i class="fa fa-trash" aria-hidden="true"></i>
              </span>
              <span>{{ $t("images.upload.imageInput.delete") }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- error -->
      <div v-if="customErrors.dimensions || customErrors.size" class="column">
        <article class="message is-danger">
          <div class="message-body">
            <div
              v-if="customErrors.dimensions"
              class="is-danger"
              :class="{ 'mb-3': customErrors.size }"
            >
              {{
                $t("form.errors.image_dimensions", {
                  WIDTH: validDimensions[0],
                  HEIGHT: validDimensions[1],
                })
              }}
            </div>
            <div v-if="customErrors.size" class="is-danger">
              {{
                $t("form.errors.image_size", {
                  ALLOWED_SIZE: filesizehumanreadable(validSize, lang),
                })
              }}
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { AppModel } from '../../../models';
import { bytesAsMb, filesizehumanreadable } from '../../../utils/FileUtils';

import ImageDescription from './image-description';

export default {
    name: 'image-input',

    components: {
        ImageDescription: ImageDescription,
    },

    props: {
        value: {
            type: Object,
            required: true,
        },
        hideDescription: {
            type: Boolean,
            default: false,
        },
        descriptionLanguage: {
            type: Object,
            default: null,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        index: {
            type: Number,
            default: () => 0,
        },

        validDimensions: {
            type: Array,
            default: () => [],
        },

        validSize: {
            type: Number,
            default: () => 0
        },

        customErrors: {
            type: Object,
            default: () => {
                return {
                    dimensions: false,
                    size: false,
                };
            },
        },
    },

    computed: {
        lang() {
            return AppModel.lang;
        },

        i18nDescriptionLabel() {
            return this.$t('images.upload.imageInput.label');
        },

        i18nDescriptionPlaceholder() {
            return this.$t('images.upload.imageInput.placeholder');
        },
    },

    methods: {
        bytesAsMb(value, digits) {
            return bytesAsMb(value, digits);
        },

        filesizehumanreadable(value, lang) {
            return filesizehumanreadable(value, lang);
        },

        removeImage() {
            this.$emit('removed', { idx: this.index });
        },

        onDescriptionInput(description) {
            this.$emit('change', { ...this.value, description });
        },
    },
};
</script>

<style lang="scss">
@import "image-input.scss";
</style>



// WEBPACK FOOTER //
// src/views/components/campsite-images/image-input.vue